export default __webpack_public_path__ + "static/media/graf-location.a7e7b705.svg";